import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { MarketResearchPageBg } from "@/components/site/MarketResearchPageBg";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/bg/media-analysis/market-research")({
  head: () => ({
    meta: [
      { title: "Анализ на пазара и медиен анализ | Perceptica" },
      {
        name: "description",
        content:
          "Perceptica използва медиен мониторинг и анализ, за да идентифицира пазарни тенденции, регулаторни сигнали, конкурентни промени и нови възможности в България и Югоизточна Европа.",
      },
      { property: "og:title", content: "Анализ на пазара и медиен анализ | Perceptica" },
      {
        property: "og:description",
        content:
          "Perceptica използва медиен мониторинг и анализ, за да идентифицира пазарни тенденции, регулаторни сигнали, конкурентни промени и нови възможности в България и Югоизточна Европа.",
      },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Анализ на пазара и медиен анализ | Perceptica" },
      { name: "twitter:description", content: "Perceptica използва медиен мониторинг и анализ, за да идентифицира пазарни тенденции, регулаторни сигнали, конкурентни промени и нови възможности в България и Югоизточна Европа." },
      { property: "og:url", content: "https://perceptica.com/bg/media-analysis/market-research" },
      ...ogImageMeta("bg", "/media-analysis/market-research"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/media-analysis/market-research", service: { name: "Пазарно проучване", description: "Пазарно проучване с медийни данни от Perceptica.", serviceType: "Пазарно проучване" } }),
  }),
  component: MarketResearchPageBg,
});
